import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Fonts } from "@snapchat/snap-design-system";

export const searchItemsContainer = css`
    height: 100%;
    margin: 0;
    border: none;
    box-shadow: none;
`;

export const searchItemsContainerV2 = css`
    .sds-card-body {
        overflow: hidden;
        height: 60vh;
        margin: 0;
    }

    ${searchItemsContainer};
`;

export const searchItemStyle = css`
    cursor: pointer;
    border-color: ${Colors.Gray.V150};

    :hover {
        background-color: ${Colors.Gray.V100};
    }
`;

export const lensInfoStyle = css`
    ${Fonts.Heading.H800};
    margin-top: 4px;
    color: ${Colors.Black.V50};
`;

export const lensRemovedStyle = css`
    opacity: 0.53;
`;

export const searchableCardHeaderStyle = css`
    input::placeholder {
        color: ${Colors.Gray.V300};
    }

    i {
        color: ${Colors.Gray.V300};
    }
`;

export const LensName = styled.span`
    ${Fonts.Heading.H500};
    margin-right: 10px;
`;
